import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DoneIcon(props: IconProps) {
    return <Icon {...props} iconKey={"done"}/>
}
